import React from 'react'
import { Box } from 'theme-ui'
import './brain.css'

import Brain from '../../images/approach/brain/brain.png'
import EMDR from '../../images/approach/brain/emdr.svg'

export function brainImage() {
  return (
    <Box
      sx={{
        width: ['50%', '60%', '50%', '100%'],
        margin: ['1em auto 2em', '0em auto 2em', '0em auto 2em', '2em 1em'],
      }}
    >
      <img
        src={Brain}
        alt="drawing of brain"
        style={{
          width: '100%',
          position: 'relative',
          display: 'block',
          marginBottom: 0,
        }}
      />
    </Box>
  )
}

export function brainMobile(paraNumber) {
  if (paraNumber === 2) {
    return (
      <Box
        sx={{
          width: ['100%', '75%'],
          margin: ['0em auto'],
        }}
      >
        <EMDR />
      </Box>
    )
  }
}

function BrainBased() {
  return (
    <Box>
      {brainImage()}
      <EMDR style={{ marginTop: '25em' }} />
    </Box>
  )
}

export default BrainBased
